<template>
	<div class="wrapper reveal-side-navigation">
		<div class="content clearfix">
			<!-- Full Width Slider Section -->
			<div class="section-block featured-media page-intro tm-slider-parallax-container">
				<div class="tm-slider-container full-width-slider">
					<ul class="tms-slides">
						<li class="tms-slide">
							<div class="tms-content">
								<div class="tms-content-inner center">
									<div class="row flex">
										<div class="column width-6 offset-3">
											<div>
												<h1 class="tms-caption mb-0 color-white animate__animated animate__slideInUp">AiroLuggage</h1>
												<div class="clear"></div>
												<p class="tms-caption lead mb-0 mb-mobile-20 color-white animate__animated animate__slideInUp">Partnership Traffic Statistics</p>
											</div>
											<!-- <div style="padding-top:15px;width:100px; height: 100px;">
                                                <span>

                                                <a href="http://safex.kr"><img width="100px" style="width: 100px;" src="../images/Safex.png"></a>
                                                </span>
                                            </div> -->
										</div>
									</div>
								</div>
							</div>
							<img src="/images/slide.jpg" class="animate__animated animate__fadeIn animate__slow" />
						</li>
					</ul>
				</div>
			</div>
			<!-- Full Width Slider Section -->

			<!-- Service Section -->
			<div class="section-block replicable-content">
        <div v-if="isPartnerGwat" width="100%" style="text-align: center;">
          <img style="margin:auto;" width="200px" src="/images/partners/gwat-logo.png" />
        </div>
        <div v-if="isPartnerTshc" width="100%" style="text-align: center;" class="tshc-logo">
          <img style="margin-right:.5rem;" src="/images/partners/tshc-logo.png" />
          <img src="/images/partners/usr-logo.png" />
        </div>
        <div v-if="isPartnerAmber" width="100%" style="text-align: center;">
          <img style="margin:auto;" width="200px" src="/images/partners/amberstudent-logo.png" />
        </div>

        <hr>

				<div class="row">
					<div class="column width-3">
						<h3 class="mb-20">Summary</h3>

<!--						<h4 class="mb-0">60 Days Period</h4>-->
<!--						<p>-->
<!--							Total Traffic = <span id="total_traffic_60d">{{ total_60 }}</span-->
<!--							><br />-->
<!--							Convereted Traffic = <span id="converted_traffic_60d">{{ converted_60 }}</span-->
<!--							><br />-->
<!--							Conversion Rate = <span id="conversion_60d">{{ rate_60 }}%</span>-->
<!--						</p>-->

<!--						<h4 class="mb-0">30 Days Period</h4>-->
						<p>
							Total Traffic = <span id="total_traffic_30d">{{ traffic_60.length }}</span
							><br />
<!--							Convereted Traffic = <span id="converted_traffic_30d">{{ converted_30 }}</span-->
<!--							><br />-->
<!--							Conversion Rate = <span id="conversion_30d">{{ rate_30 }}%</span>-->
						</p>
					</div>
					<div class="column width-8 offset-1">
						<div>
<!--								<h4 class="mb-20">All Converted Traffic - Past 60 Days</h4>-->
<!--								<table id="listing_converted">-->
<!--									<tr>-->
<!--										<th scope="col">#</th>-->
<!--										<th scope="col" style="padding-left:10px;">Partnership</th>-->
<!--										<th scope="col" style="padding-left:50px;">Landing</th>-->
<!--										<th scope="col" style="padding-left:0px;">Time</th>-->
<!--										<th scope="col" style="padding-left:40px;">Confirmed Stripe Payment ID</th>-->
<!--									</tr>-->

<!--									<tr v-for="traffic in traffic_60_converted" v-bind:key="traffic.id">-->
<!--										<td style="padding-left:1px;">{{ traffic.id }}</td>-->
<!--										<td style="padding-left:10px;">{{ traffic.source }}</td>-->
<!--										<td style="padding-left:50px;">{{ traffic.landing }}</td>-->
<!--										<td style="padding-left:80px;">{{ formattedDate(traffic.time) }}</td>-->
<!--										<td style="padding-left:60px;">{{ traffic.confirmed_booking_id }}</td>-->
<!--									</tr>-->
<!--								</table>-->

<!--								<hr />-->

              <h4 class="mb-20">All Arrived Traffic</h4>
              <div class="table-responsive">
                <table id="listing_traffic">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Partnership</th>
                    <!--										<th scope="col" style="padding-left:50px;">Landing</th>-->
                    <th scope="col">Time</th>
                    <!--										<th scope="col" style="padding-left:40px;">Confirmed Stripe Payment ID</th>-->
                    <th scope="col">Username</th>
                    <th scope="col">Bag Count</th>
                  </tr>
                  <tr v-for="traffic in traffic_60" v-bind:key="traffic.id">
                    <td>{{ traffic.id }}</td>
                    <td>{{ traffic.partner }}</td>
                    <!--										<td style="padding-left:50px;">{{ traffic.landing }}</td>-->
                    <td>{{ formattedDate(traffic.createdAt) }}</td>
                    <td>{{ traffic.username }}</td>
                    <td>{{ traffic.bagCount }}</td>
                  </tr>
                </table>
              </div>
						</div>
					</div>
				</div>
			</div>

			<!-- Hero 5 Section -->
			<div class="section-block hero-5 hero-5-2 clear-height show-media-column-on-mobile bkg-ash">
				<div class="media-column width-6"></div>
				<div class="row">
					<div class="column width-6 push-6">
						<div class="hero-content split-hero-content">
							<div class="hero-content-inner left"
                   v-animate-onscroll="'animate__animated animate__slideInRight animate__slow'">
								<p class="lead color-white">What makes AiroLuggage unique?</p>
								<div class="pricing-table-text">
									<ul class="list-unstyled">
										<li><span class="icon-dot-single color-white"></span> We're frequent travellers</li>
										<li><span class="icon-dot-single color-white"></span> We only use tried and trusted couriers</li>
										<li><span class="icon-dot-single color-white"></span> There are no middlemen to be paid</li>
										<li><span class="icon-dot-single color-white"></span> Our service is simple and straightforward</li>
										<li><span class="icon-dot-single color-white"></span> We are driven by innovation and will continually add new routes</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Hero 5 Section End -->
		<!-- START CALL TO ACTION SECTION -->
		<div class="section-block pt-40 pb-40">
			<div class="row flex">
				<div class="column width-8 left" v-animate-onscroll="'animate__animated animate__slideInLeft animate__slow'">
					<p class="lead mb-0 mb-mobile-20">We collect your luggage from your home and deliver it straight to your hotel, so it's waiting for you on arrival.</p>
				</div>
				<div class="column width-4 v-align-middle right left-on-mobile " v-animate-onscroll="'animate__animated animate__slideInRight animate__slow'">
					<div>
						<router-link to="/booking" class="button rounded xlarge no-margins bkg-red bkg-hover-theme color-white color-hover-white mb-0">Book Now</router-link>
					</div>
				</div>
			</div>
		</div>
		<!-- END CALL TO ACTION SECTION  -->
	</div>
</template>

<script>
import { mapState } from "vuex";
import * as R from "ramda";
import * as dayjs from "dayjs";
import axios from "axios";

export default {
  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://airoluggage.com/check-traffic'}
    ],
    script: [{
      type: 'application/ld+json',
      json: [
        {
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": "Partnership Traffic Statistics",
          "author": [{
            "@type": "Organization",
            "name": "AiroLuggage",
            "url": "https://airoluggage.com"
          }]
        }, {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Partnership Traffic Statistics",
          }]
        },
      ]
    }],
  },
    data() {
        return {
            total_60: 0,
            converted_60: 0,
            rate_60: 0,
            total_30: 0,
            converted_30: 0,
            rate_30: 0,
            traffic_60: [],
            traffic_60_converted: [],
            traffic_30: [],
            traffic_30_converted: [],
        };
    },
    props: ["partner"],
    computed: {
        ...mapState("traffic", ["traffic"]),
        isPartnerGwat: function () {
          return this.partner && this.partner === "gwat";
        },
        isPartnerTshc: function () {
          return this.partner && this.partner === "tshc";
        },
        isPartnerAmber: function () {
          return this.partner && this.partner === "amberstudent";
        },
    },
    mounted() {
        this.getTracks();
        // this.$store
        //     .dispatch("traffic/fetchAllTraffic")
        //     .then(this.performCalcs());
    },
    methods: {
        getTracks() {
            if (this.isPartnerGwat || this.isPartnerTshc || this.isPartnerAmber) {
              axios.get(`/track/${this.partner}`).then(response => {
                if (response.status === 200) {
                  this.traffic_60 = response.data
                }
              })
            }
        },
        formattedDate(dt) {
            return dayjs(dt).format("MMM DD YYYY hh:mm");
        },
        performCalcs() {
            if (this.traffic) {
                this.total_60 = this.traffic.length * 2;

                const date30DaysAgo = dayjs().subtract(30, "day");
                const date60DaysAgo = dayjs().subtract(60, "day");
                this.traffic_30 = R.compose(
                    R.sort(R.descend(R.prop("id"))),
                    R.filter((tr) => dayjs(tr.time) >= date30DaysAgo)
                )(this.traffic);
                this.traffic_30_converted = R.filter(
                    (tr) => tr.confirmedBookingId
                )(this.traffic_30);

                this.traffic_60 = R.compose(
                    R.sort(R.descend(R.prop("id"))),
                    R.filter((tr) => dayjs(tr.time) >= date60DaysAgo)
                )(this.traffic);
                this.traffic_60_converted = R.filter(
                    (tr) => tr.confirmedBookingId
                )(this.traffic_60);

                this.total_30 = this.traffic_30.length;
                this.converted_30 = this.traffic_30_converted.length;
                this.rate_30 =
                    this.total_30 > 0
                        ? Number(
                              (
                                  100.0 *
                                  (this.converted_30 / this.total_30)
                              ).toFixed(1)
                          ).toString()
                        : "";

                this.total_60 = this.traffic_60.length;
                this.converted_60 = this.traffic_60_converted.length;
                this.rate_60 =
                    this.total_60 > 0
                        ? Number(
                              (
                                  100.0 *
                                  (this.traffic_60_converted.length /
                                      this.traffic_60.length)
                              ).toFixed(1)
                          ).toString()
                        : "";
            }
        },
    },
};
</script>

<style lang="css" scoped>
.tms-slide {
    visibility: visible;
}
.tms-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.tms-caption {
    opacity: 1;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

#listing_traffic {
  width: 100%;
}

#listing_traffic td, #listing_traffic th {
  padding: 1.5rem;
  text-align: center;
  white-space: nowrap;
}

.tshc-logo img {
  height: 10rem;
  object-fit: contain;
}
</style>